import { reload } from '@mindtickle/utils';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { APPLICATIONS, getApplicationAccessLink } from '~/components/ApplicationUrls';
import { useLogout, useUserAuth } from '~/components/Auth';
import { IntlType } from '~/components/GlobalHeader/Shared/type';
import useDropdownData from '../../../../Shared/hooks/useDropdownData';
import useTracker from '../../../hooks/useTracker';
import { MIXPANEL_EVENTS } from '../../../mixpanel/config';

interface UseProfileDataProps {
  intl: IntlType;
}

const useProfileData = ({ intl }: UseProfileDataProps) => {
  const auth = useUserAuth();
  const { company, ...user } = auth;

  const logout = useLogout();
  const track = useTracker();
  const navigate = useNavigate();

  const onLogout = useCallback(async () => {
    await logout();
    reload(getApplicationAccessLink(APPLICATIONS.LOGIN));
  }, [logout]);

  const trackVisibility = useCallback(() => {
    track(MIXPANEL_EVENTS.MY_PROFILE_TOGGLED);
  }, [track]);

  const { isVisible, onHideDropdownContent, handleVisibilityChange } = useDropdownData({
    trackVisibility,
  });

  const actionConfig = {
    user,
    company,
    track,
    navigate,
    logout: onLogout,
    onHideDropdownContent,
    intl,
  };

  return {
    user,
    actionConfig,
    isVisible,
    handleVisibilityChange,
  };
};

export default useProfileData;
